"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listOfCustomers = exports.excludeCampaignProducts = exports.getCampaignCoverageProducts = exports.getCampaignCoverage = exports.getCampaignProducts = exports.cancelQueuedCampaign = exports.retryQueuedCampaign = exports.cancelCampaign = exports.activateCampaign = exports.deactivateCampaign = exports.getResolveConflictCampaign = exports.campaignControllerSetVariantCosts = exports.setVariantCosts = exports.resyncCampaignCosts = exports.getCampaignMissingCostVariants = exports.getCampaignMissingCostCount = exports.getCampaignOrders = exports.checkProductsInCollections = exports.searchCustomers = exports.campaignControllerGetCampaignStats = exports.updateAndActivateCampaign = exports.deleteCampaign = exports.getCampaign = exports.updateCampaign = exports.resolveProduct = exports.getBundleSharing = exports.getCampaignOverlaps = exports.upsellOfferPreview = exports.upsellSuggestions = exports.upsellLadderAxes = exports.xsellSuggestions = exports.xsellOfferPreview = exports.bundleComboRetry = exports.bundleComboEligibility = exports.bundleSlotCoverage = exports.previewCampaignCoverageProducts = exports.excludeBundleProducts = exports.previewBundleSharing = exports.previewCampaignCoverage = exports.getActiveCampaignRevenueReport = exports.campaignControllerTest = exports.getEstimateProducts = exports.estimateRequest = exports.conflictDraft = exports.campaignActivationRequest = exports.resolveConflict = exports.createAndActivateCampaign = exports.getCampaigns = exports.createCampaign = exports.pauseAllCampaigns = void 0;
exports.importCampaigns = exports.campaignControllerProgressSse = exports.campaignControllerStatusSse = exports.listOfCustomersTags = exports.listOfCustomersSegments = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Pause all active campaigns for a shop (full deactivation with Shopify price reversion)
*/
const pauseAllCampaigns = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/pause-all`, method: 'post'
    });
};
exports.pauseAllCampaigns = pauseAllCampaigns;
/**
* @summary Create campaign for a shop
*/
const createCampaign = (campaignDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: campaignDto
    });
};
exports.createCampaign = createCampaign;
/**
* @summary Get campaigns of a shop
*/
const getCampaigns = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns`, method: 'get',
        params
    });
};
exports.getCampaigns = getCampaigns;
/**
* @summary Create and Activate campaign for a shop
*/
const createAndActivateCampaign = (campaignDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/createAndActivate`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: campaignDto
    });
};
exports.createAndActivateCampaign = createAndActivateCampaign;
/**
* @summary resolveConflict
*/
const resolveConflict = (resolveConflictBody) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/resolveConflict`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: resolveConflictBody
    });
};
exports.resolveConflict = resolveConflict;
/**
* @summary Conflict Draft campaign for a shop
*/
const campaignActivationRequest = (campaignActivationRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/campaignActivationRequest`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: campaignActivationRequestDto
    });
};
exports.campaignActivationRequest = campaignActivationRequest;
/**
* @summary Conflict Draft campaign for a shop
*/
const conflictDraft = (campaignDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/conflictDraft`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: campaignDto
    });
};
exports.conflictDraft = conflictDraft;
/**
* @summary Product estimation request
*/
const estimateRequest = (campaignDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/estimate`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: campaignDto
    });
};
exports.estimateRequest = estimateRequest;
/**
* @summary Get Product estimation
*/
const getEstimateProducts = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/estimate`, method: 'get',
        params
    });
};
exports.getEstimateProducts = getEstimateProducts;
const campaignControllerTest = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/autoUpdate`, method: 'get'
    });
};
exports.campaignControllerTest = campaignControllerTest;
/**
* @summary Get active campaigns revenue
*/
const getActiveCampaignRevenueReport = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/getActiveCampaignsRevenueReport`, method: 'get'
    });
};
exports.getActiveCampaignRevenueReport = getActiveCampaignRevenueReport;
/**
* @summary Preview a draft campaign's coverage (scope/enforcing/overridden) without saving
*/
const previewCampaignCoverage = (campaignCoveragePreviewDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/coverage`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: campaignCoveragePreviewDto
    });
};
exports.previewCampaignCoverage = previewCampaignCoverage;
/**
* @summary Which other live bundles use the same products as a bundle draft (sharing is allowed, this only reports it), plus shared free-gift items — nothing persisted
*/
const previewBundleSharing = (campaignCoveragePreviewDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/bundle/sharing`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: campaignCoveragePreviewDto
    });
};
exports.previewBundleSharing = previewBundleSharing;
/**
* @summary "Limit to one set": keep products out of a bundle by adding them to its slot exclusions, then recompute it
*/
const excludeBundleProducts = (id, bundleExcludeProductsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/bundle/exclude-products`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bundleExcludeProductsDto
    });
};
exports.excludeBundleProducts = excludeBundleProducts;
/**
* @summary Paginated product list backing one of a DRAFT campaign's coverage groups (no id to read a saved doc from yet)
*/
const previewCampaignCoverageProducts = (previewCoverageProductsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/coverage/products`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: previewCoverageProductsDto
    });
};
exports.previewCampaignCoverageProducts = previewCampaignCoverageProducts;
/**
* @summary Coverage per bundle slot (products, variants, cost coverage, shared products) for a draft — no campaign id required, nothing persisted
*/
const bundleSlotCoverage = (bundleSlotCoverageRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/bundle/slot-coverage`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bundleSlotCoverageRequestDto
    });
};
exports.bundleSlotCoverage = bundleSlotCoverage;
/**
* @summary Phase 4 Combo: live eligibility + PDP-style preview (component/option/variant counts, sum price) for the Combo toggle on a draft — no campaign id required, nothing persisted
*/
const bundleComboEligibility = (bundleComboEligibilityRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/bundle/combo-eligibility`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bundleComboEligibilityRequestDto
    });
};
exports.bundleComboEligibility = bundleComboEligibility;
/**
* @summary Retry a failed Combo publish (republishes to the SAME combo product when one exists). Returns the combo status summary.
*/
const bundleComboRetry = (bundleComboRetryRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/bundle/combo-retry`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bundleComboRetryRequestDto
    });
};
exports.bundleComboRetry = bundleComboRetry;
/**
* @summary Trigger count + resolved offer list (stock/price/cost/margin) for a cross-sell draft — no campaign id required, nothing persisted
*/
const xsellOfferPreview = (xsellOfferPreviewRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/xsell/offer-preview`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: xsellOfferPreviewRequestDto
    });
};
exports.xsellOfferPreview = xsellOfferPreview;
/**
* @summary Smart Suggestions engine (Ultimate): ranked cross-sell offer candidates for the given trigger products, plus the run metadata the editor uses to render an honest banner
*/
const xsellSuggestions = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/xsell/suggestions`, method: 'get',
        params
    });
};
exports.xsellSuggestions = xsellSuggestions;
/**
* @summary Bigger-variant axis analysis: per product, every option axis with its price-ladder groups and whether it qualifies (prices strictly ordered) — no campaign id required, nothing persisted
*/
const upsellLadderAxes = (upsellLadderAxesRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/upsell/ladder-axes`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: upsellLadderAxesRequestDto
    });
};
exports.upsellLadderAxes = upsellLadderAxes;
/**
* @summary Smart ladders rule engine: ranked upgrade candidates (same product type, 1.15-3x price, margin not worse than 5 pts when both costs are known, in stock) for the given trigger products — nothing persisted
*/
const upsellSuggestions = (upsellSuggestionsRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/upsell/suggestions`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: upsellSuggestionsRequestDto
    });
};
exports.upsellSuggestions = upsellSuggestions;
/**
* @summary Cheapest trigger price + resolved upgrade offers (manual / pool / smart) with the downsell flag per offer for an upsell draft — no campaign id required, nothing persisted
*/
const upsellOfferPreview = (upsellOfferPreviewRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/upsell/offer-preview`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: upsellOfferPreviewRequestDto
    });
};
exports.upsellOfferPreview = upsellOfferPreview;
/**
* @summary Every pair of campaigns currently competing for the same products
*/
const getCampaignOverlaps = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/overlaps`, method: 'get'
    });
};
exports.getCampaignOverlaps = getCampaignOverlaps;
/**
* @summary Pairs of live bundles that share products (informational, sharing is allowed)
*/
const getBundleSharing = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/overlaps/bundle-sharing`, method: 'get'
    });
};
exports.getBundleSharing = getBundleSharing;
/**
* @summary Which campaign, if any, currently discounts this product
*/
const resolveProduct = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/resolve-product`, method: 'get',
        params
    });
};
exports.resolveProduct = resolveProduct;
/**
* @summary Update campaign for a shop
*/
const updateCampaign = (id, campaignDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}`, method: 'put',
        headers: { 'Content-Type': 'application/json', },
        data: campaignDto
    });
};
exports.updateCampaign = updateCampaign;
/**
* @summary Get campaign for a shop
*/
const getCampaign = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}`, method: 'get'
    });
};
exports.getCampaign = getCampaign;
/**
* @summary Delete campaign for a shop
*/
const deleteCampaign = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}`, method: 'delete'
    });
};
exports.deleteCampaign = deleteCampaign;
/**
* @summary Update and activate campaign for a shop
*/
const updateAndActivateCampaign = (id, campaignDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/updateAndActivate`, method: 'put',
        headers: { 'Content-Type': 'application/json', },
        data: campaignDto
    });
};
exports.updateAndActivateCampaign = updateAndActivateCampaign;
const campaignControllerGetCampaignStats = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/stats`, method: 'get',
        params
    });
};
exports.campaignControllerGetCampaignStats = campaignControllerGetCampaignStats;
/**
* @summary Search customers by name/email/phone (bounded, for the picker UI)
*/
const searchCustomers = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/search_customers`, method: 'get',
        params
    });
};
exports.searchCustomers = searchCustomers;
/**
* @summary Which of these products are in at least one of these collections
*/
const checkProductsInCollections = (productsInCollectionsRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/scope-check/collections`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: productsInCollectionsRequestDto
    });
};
exports.checkProductsInCollections = checkProductsInCollections;
/**
* @summary Get paginated orders for a campaign
*/
const getCampaignOrders = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/orders`, method: 'get'
    });
};
exports.getCampaignOrders = getCampaignOrders;
/**
* @summary Count of the campaign's products with no cost set (from the local VariantCost table — no Shopify call)
*/
const getCampaignMissingCostCount = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/missing-cost-count`, method: 'get'
    });
};
exports.getCampaignMissingCostCount = getCampaignMissingCostCount;
/**
* @summary The campaign's variants with no cost set, grouped by product (local VariantCost table — no Shopify call), for the Add missing costs modal
*/
const getCampaignMissingCostVariants = (id, params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/missing-cost-variants`, method: 'get',
        params
    });
};
exports.getCampaignMissingCostVariants = getCampaignMissingCostVariants;
/**
* @summary Re-query Shopify for the campaign's missing variant costs, persist them, and return the refreshed count
*/
const resyncCampaignCosts = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/resync-costs`, method: 'post'
    });
};
exports.resyncCampaignCosts = resyncCampaignCosts;
/**
* @summary Write a Cost per item value for a list of variants to Shopify (productVariantsBulkUpdate), and persist the accepted values locally in VariantCost
*/
const setVariantCosts = (lookupVariantCostsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/variant-costs/lookup`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: lookupVariantCostsDto
    });
};
exports.setVariantCosts = setVariantCosts;
const campaignControllerSetVariantCosts = (setVariantCostsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/variant-costs`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: setVariantCostsDto
    });
};
exports.campaignControllerSetVariantCosts = campaignControllerSetVariantCosts;
/**
* @summary Get Resolve Conflict campaign for a shop
*/
const getResolveConflictCampaign = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/resolveConflicts/${id}`, method: 'get'
    });
};
exports.getResolveConflictCampaign = getResolveConflictCampaign;
/**
* @summary Deactivate campaign for a shop
*/
const deactivateCampaign = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/deactivate`, method: 'get'
    });
};
exports.deactivateCampaign = deactivateCampaign;
/**
* @summary activate campaign for a shop
*/
const activateCampaign = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/activate`, method: 'get'
    });
};
exports.activateCampaign = activateCampaign;
/**
* @summary Cancel campaign for a shop by id
*/
const cancelCampaign = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/cancel`, method: 'get'
    });
};
exports.cancelCampaign = cancelCampaign;
/**
* @summary Re-enqueue a campaign that has been Queued too long with nobody processing it (idempotent: never duplicates a live job)
*/
const retryQueuedCampaign = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/queued/retry`, method: 'post'
    });
};
exports.retryQueuedCampaign = retryQueuedCampaign;
/**
* @summary Take a queued (not yet running) campaign out of the queue and return it to Inactive so it can be edited
*/
const cancelQueuedCampaign = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/queued/cancel`, method: 'post'
    });
};
exports.cancelQueuedCampaign = cancelQueuedCampaign;
/**
* @summary Get campaigns of a shop
*/
const getCampaignProducts = (id, params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/products`, method: 'get',
        params
    });
};
exports.getCampaignProducts = getCampaignProducts;
/**
* @summary A saved/active campaign's coverage (scope/enforcing/overridden), read from its live state
*/
const getCampaignCoverage = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/coverage`, method: 'get'
    });
};
exports.getCampaignCoverage = getCampaignCoverage;
/**
* @summary Paginated product list backing one of a campaign's coverage groups
*/
const getCampaignCoverageProducts = (id, params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/coverage/products`, method: 'get',
        params
    });
};
exports.getCampaignCoverageProducts = getCampaignCoverageProducts;
/**
* @summary Yield products to another campaign, or take products over from one — generalizes the campaign's Keep/Move resolution
*/
const excludeCampaignProducts = (id, excludeProductsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/${id}/exclude-products`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: excludeProductsDto
    });
};
exports.excludeCampaignProducts = excludeCampaignProducts;
/**
* @summary List of customers retrieved successfully
*/
const listOfCustomers = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/all_customers/${id}`, method: 'get'
    });
};
exports.listOfCustomers = listOfCustomers;
/**
* @summary List of customers retrieved successfully
*/
const listOfCustomersSegments = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/all_customers_segments/${id}`, method: 'get'
    });
};
exports.listOfCustomersSegments = listOfCustomersSegments;
/**
* @summary List of customers retrieved successfully
*/
const listOfCustomersTags = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/all_customersTags/${id}`, method: 'get'
    });
};
exports.listOfCustomersTags = listOfCustomersTags;
const campaignControllerStatusSse = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/sse/status`, method: 'get'
    });
};
exports.campaignControllerStatusSse = campaignControllerStatusSse;
const campaignControllerProgressSse = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/sse/progress`, method: 'get',
        params
    });
};
exports.campaignControllerProgressSse = campaignControllerProgressSse;
/**
* @summary Import campaigns from encoded export payload
*/
const importCampaigns = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/campaigns/import`, method: 'post'
    });
};
exports.importCampaigns = importCampaigns;
